var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpenses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4297 12.5C11.0927 12.5 11.7286 12.2366 12.1975 11.7678C12.6663 11.2989 12.9297 10.663 12.9297 10C12.9297 9.33696 12.6663 8.70107 12.1975 8.23223C11.7286 7.76339 11.0927 7.5 10.4297 7.5C9.76665 7.5 9.13076 7.76339 8.66192 8.23223C8.19308 8.70107 7.92969 9.33696 7.92969 10C7.92969 10.663 8.19308 11.2989 8.66192 11.7678C9.13076 12.2366 9.76665 12.5 10.4297 12.5Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.429688 5C0.429688 4.66848 0.561384 4.35054 0.795804 4.11612C1.03022 3.8817 1.34817 3.75 1.67969 3.75H19.1797C19.5112 3.75 19.8292 3.8817 20.0636 4.11612C20.298 4.35054 20.4297 4.66848 20.4297 5V15C20.4297 15.3315 20.298 15.6495 20.0636 15.8839C19.8292 16.1183 19.5112 16.25 19.1797 16.25H1.67969C1.34817 16.25 1.03022 16.1183 0.795804 15.8839C0.561384 15.6495 0.429688 15.3315 0.429688 15V5ZM4.17969 5C4.17969 5.66304 3.9163 6.29893 3.44745 6.76777C2.97861 7.23661 2.34273 7.5 1.67969 7.5V12.5C2.34273 12.5 2.97861 12.7634 3.44745 13.2322C3.9163 13.7011 4.17969 14.337 4.17969 15H16.6797C16.6797 14.337 16.9431 13.7011 17.4119 13.2322C17.8808 12.7634 18.5166 12.5 19.1797 12.5V7.5C18.5166 7.5 17.8808 7.23661 17.4119 6.76777C16.9431 6.29893 16.6797 5.66304 16.6797 5H4.17969Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenses);
export default __webpack_public_path__ + "static/media/Expenses.56d9bfd9212515cdd385ae185fd2d93e.svg";
export { ForwardRef as ReactComponent };